import type { AxisProps } from "@nivo/axes";
import { COLORS } from "../constants";

export const lineChartTheme = (isLightAppearance: boolean) => ({
  background: "transparent",
  text: {
    fill: isLightAppearance ? COLORS.light.textColor : COLORS.dark.textColor,
  },
  grid: {
    line: {
      stroke: isLightAppearance ? COLORS.light.grid : COLORS.dark.grid,
      strokeWidth: 1,
    },
  },
  axis: {
    ticks: {
      text: {
        fill: isLightAppearance ? COLORS.light.axis : COLORS.dark.axis,
      },
    },
  },
  crosshair: {
    line: {
      stroke: isLightAppearance ? COLORS.light.axis : COLORS.dark.axis,
      strokeWidth: 1,
      strokeOpacity: 0,
    },
  },
});

export const baseAxisProps: Partial<AxisProps> = {
  tickSize: 5,
  tickPadding: 5,
  tickRotation: 0,
  legend: "",
  legendPosition: "middle",
};
